import { isNestedBaseOption } from './isNestedBaseOption';
import { BaseOption, NestedBaseOption } from '../types';

export const getFlattenedOptions = (options: BaseOption[] | NestedBaseOption[]) =>
  options.flatMap((option) => (isNestedBaseOption(option) ? option.options : option));
